export enum DocType {
  LEGACY = 'legacy',
  S1000D = 'S1000D',
}
